// TODO: as long Storybook doesn't support template literal types we've to comment it out and use the legacy way :/
// instead of enum here we use the const assertions approach
export const MessageType = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger', // no danger for completion

  // Below for `completion` only
  ERROR: 'error',

  EMAIL: 'email',
  EMAIL_ERROR: 'email-error',
  EMAIL_SUCCESS: 'email-success',

  ACCOUNT: 'account',
  ACCOUNT_ERROR: 'account-error',
  ACCOUNT_SUCCESS: 'account-success',
  ACCOUNT_SYNC: 'account-sync',

  COUPON: 'coupon',
  COUPON_SUCCESS: 'coupon-success',
  COUPON_ERROR: 'coupon-error',
  COUPON_WARNING: 'coupon-warning',

  LIST_EMPTY: 'list-empty',
  LIST_SYNC: 'list-sync',
  LIST_SUCCESS: 'list-success',

  BROWSER_SUCCESS: 'browser-success',
  BROWSER_ERROR: 'browser-error',

  LOGIN: 'login',
  NO_RESULTS: 'no-results',
  BOX_EMPTY: 'box-empty',
  HOURGLASS: 'hourglass',
  USERS: 'users',
  LOCK: 'lock',

  SIGN_404: 'sign-404',
  SIGN_UNDER_CONSTRUCTION: 'sign-under-construction',
  SIGN_WARNING: 'sign-warning',

  NO_REPLIES: 'no-replies',

  CUSTOM: 'custom'
} as const;
export type MessageType = (typeof MessageType)[keyof typeof MessageType];
